import { render, staticRenderFns } from "./FormasTable.vue?vue&type=template&id=f072e0e0&"
import script from "./FormasTable.vue?vue&type=script&lang=js&"
export * from "./FormasTable.vue?vue&type=script&lang=js&"
import style0 from "./FormasTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports